import { Product } from "../../types";

export const initialNewProductValues:Product = {
    image: '',
    name: '',
    stock: 0,
    price: '',
    marca: '',
    category: '',
    subcategory: '',
}